import RestApiModel from "@/api/Model/RestApiModel";

class PolicyCertificate extends RestApiModel {
  static getResourceEndpoint() {
    return '/GetPolicyCertificate';
  }
}

export default PolicyCertificate;
